// extracted by mini-css-extract-plugin
module.exports = {"Colors":"App.colors_Colors__1LUGj"};